import { useFetchReturnsArray as useFetch } from './useFetch';
import config from '../../../configWrapper';

function formatUrl(account, refreshKey) {
  if (account && account.value) {
    const url = `${config.serverUrl}/accounts/api-status?accountId=${account.value}`;
    // refreshKey is not needed by the backend, but appending it forces
    // useFetch's effect (which watches the url) to re-run on demand, so
    // callers can trigger a manual refetch (e.g. after saving settings
    // in a modal) without needing to change the account selection.
    return refreshKey ? `${url}&refresh=${refreshKey}` : url;
  }
  return undefined;
}

export default function useAccountApiStatus(account, refreshKey) {
  return useFetch(formatUrl(account, refreshKey));
}
